import React, { useState, useEffect } from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import TextField from "@material-ui/core/TextField";
import { toast } from "react-toastify";
import { i18n } from "../../translate/i18n";

const EditMessageDialog = ({ open, onClose, message, onSave }) => {
  const [text, setText] = useState("");
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (open && message) {
      setText(message.body || "");
    }
  }, [open, message]);

  const handleClose = () => {
    if (!saving) {
      setText("");
      onClose();
    }
  };

  const handleSave = async () => {
    if (saving) return;
    const trimmedText = (text || "").trim();
    setSaving(true);
    try {
      await onSave(trimmedText);
      handleClose();
    } catch (err) {
      toast.error(i18n.t("messagesList.editMessageError"), {
        toastId: "editMessageError"
      });
    } finally {
      setSaving(false);
    }
  };

  if (!message) return null;

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="edit-message-dialog"
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle id="edit-message-dialog">
        {i18n.t("messagesList.editMessageDialogTitle")}
      </DialogTitle>
      <DialogContent dividers>
        <TextField
          autoFocus
          margin="dense"
          label={i18n.t("messagesList.editMessage")}
          fullWidth
          multiline
          minRows={3}
          maxRows={10}
          value={text}
          onChange={(e) => setText(e.target.value)}
          variant="outlined"
          disabled={saving}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="default" disabled={saving}>
          {i18n.t("confirmationModal.buttons.cancel")}
        </Button>
        <Button
          onClick={handleSave}
          color="primary"
          variant="contained"
          disabled={saving}
        >
          {saving ? "..." : i18n.t("confirmationModal.buttons.confirm")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EditMessageDialog;
